// import React, { useEffect } from "react";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { WebService } from "../../Services/WebService";
// import { useDispatch, useSelector } from "react-redux";
// import { WSErrorAlert, WSSuccessAlert, WSWarningAlert } from "../../Services/WSAlert";
// import { AttachFileOutlined } from "@mui/icons-material";
// import ActionButton from "../../Services/ActionButton";
// const { forwardRef, useState, useImperativeHandle } = React;

// const BroadcastSignatureModal = (prop, ref) => {
//   const dispatch = useDispatch();
//   const [show, setShow] = useState(false);
//   const [documentData, setDocumentData] = useState(null);
//   const [file, setFile] = useState(null);
//   const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
//   const UserInfo = useSelector((s) => s.auth.UserInfo ?? {});

//   useImperativeHandle(ref, () => ({
//     openModal: async (docData) => {
//       setFile(null);
//       await getCoordinates();
//       setDocumentData(docData);
//       setShow(true);
//     },
//   }));

//   const handleClose = () => {
//     setShow(false);
//     setDocumentData(null);
//     setFile(null);
//   };

//   const getCoordinates = async () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const { latitude, longitude } = position.coords;
//           setCoordinates({ latitude, longitude });
//         },
//         (error) => {
//           WSWarningAlert("", "Location is required for signature.");
//         }
//       );
//     } else {
//       WSWarningAlert("", "Location is required for signature.");
//     }
//   };

//   const SignDocument = async () => {
//     if (documentData?.RequireSignature && !file) {
//       WSErrorAlert("", "Please attach the signed document");
//       return;
//     }

//     handleClose();
//     let fileDetails = null;

//     // Upload the file if provided
//     if (file) {
//       fileDetails = await WebService({
//         endPoint: "upload/File",
//         body: file,
//         isFile: true,
//         dispatch,
//       });
//     }

//     // Prepare data for updating broadcast document recipient
//     let updateData = {
//       SignDateTimestamp: new Date(),
//       SignedDocumentFilePath: fileDetails?.filename || null,
//       Location: JSON.stringify(coordinates),
//     };

//     // Update broadcast document recipient status
//     await WebService({
//       endPoint: `CommonUtility/BroadcastDocumentRecipient?BroadcastDocumentId=${documentData.BroadcastDocumentId}&EmployeeId=${UserInfo.UserId}`,
//       method: "PUT",
//       body: updateData,
//       dispatch,
//     });

//     // Send notification
//     const notificationData = {
//       BroadcastDocumentId: documentData.BroadcastDocumentId,
//       EmployeeId: UserInfo.UserId,
//     };

//     await WebService({
//       endPoint: `Document/SendNotification`,
//       method: "POST",
//       body: notificationData,
//       dispatch,
//     }).then(() => {
//       WSSuccessAlert("", `Document '${documentData?.Title}' has been signed successfully`);
//     });

//     if (prop.callBackEvent) {
//       prop.callBackEvent();
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose}>
//       <Modal.Body>
//         <div
//           className="swal2-icon swal2-warning swal2-icon-show mt-0"
//           style={{ display: "flex" }}
//         >
//           <div className="swal2-icon-content">!</div>
//         </div>
//         <h2
//           className="swal2-title"
//           id="swal2-title"
//           style={{ display: "block", color: "#545454" }}
//         >
//           Confirm Document Signing
//         </h2>
//         <div
//           className="swal2-html-container mx-0"
//           id="swal2-html-container"
//           style={{ display: "block", color: "#545454" }}
//         >
//           By clicking 'Yes, Sign it!', you confirm that you have reviewed the
//           document '{documentData?.Title}' and agree to its terms. Your location will be recorded as part of your signature. This action is
//           final and cannot be undone.
//         </div>
        
//         {documentData?.RequireSignature && (
//           <div className="d-flex justify-content-center my-2">
//             <label
//               htmlFor="inputGroupFile04"
//               className="d-flex align-items-center gap-2 mb-2 mb-md-0"
//             >
//               <span>
//                 {file ? file.name : "Attach the Signed Document (Required)"}
//               </span>
//               <input
//                 type="file"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 className="form-control d-none"
//                 id="inputGroupFile04"
//                 accept=".pdf,.jpg,.jpeg,.png"
//               />
//               {!file && (
//                 <span className="btn btn-outline-primary">
//                   <AttachFileOutlined />
//                 </span>
//               )}
//             </label>
//             {file && (
//               <ActionButton
//                 IconName="Close"
//                 IconTooltip="Remove file"
//                 onClick={() => setFile(null)}
//               />
//             )}
//           </div>
//         )}

//         {coordinates.latitude && coordinates.longitude && (
//           <div className="text-center my-2">
//             <small className="text-muted">
//               📍 Location: {coordinates.latitude.toFixed(6)}, {coordinates.longitude.toFixed(6)}
//             </small>
//           </div>
//         )}

//         <span className="d-flex justify-content-center gap-2 mt-3">
//           <Button
//             variant="secondary"
//             style={{ fontWeight: "bold" }}
//             onClick={handleClose}
//           >
//             No, Review Again
//           </Button>
//           <Button
//             variant="primary"
//             style={{ fontWeight: "bold" }}
//             onClick={SignDocument}
//             disabled={documentData?.RequireSignature && !file}
//           >
//             Yes, Sign it!
//           </Button>
//         </span>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default forwardRef(BroadcastSignatureModal);


import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { WSSuccessAlert, WSWarningAlert } from "../../Services/WSAlert";
const { forwardRef, useState, useImperativeHandle } = React;

const BroadcastSignatureModal = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
  const UserInfo = useSelector((s) => s.auth.BasicInfo ?? {});

  useImperativeHandle(ref, () => ({
    openModal: async (docData) => {
      await getCoordinates();
      setDocumentData(docData);
      setShow(true);
    },
  }));

  const handleClose = () => {
    setShow(false);
    setDocumentData(null);
  };

  const getCoordinates = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCoordinates({ latitude, longitude });
        },
        (error) => {
          WSWarningAlert("", "Location is required for signature.");
        }
      );
    } else {
      WSWarningAlert("", "Location is required for signature.");
    }
  };

  const SignDocument = async () => {
    handleClose();

    // Prepare data for updating broadcast document recipient
    let updateData = {
      SignDateTimestamp: new Date(),
      SignedDocumentFilePath: documentData?.DocumentPath || null, // Use the same document path
      Location: JSON.stringify(coordinates),
    };

    // Update broadcast document recipient status
    // await WebService({
    //   endPoint: `CommonUtility/BroadcastDocumentRecipient?BroadcastDocumentId=${documentData.BroadcastDocumentId}&EmployeeId=${UserInfo.EmployeeId}`,
    //   method: "PUT",
    //   body: updateData,
    //   dispatch,
    // });

     await WebService({
      endPoint: `Document/BroadcastDocumentRecipient?BroadcastDocumentId=${documentData.BroadcastDocumentId}&EmployeeId=${UserInfo.EmployeeId}`,
      method: "PUT",
      body: updateData,
      dispatch,
    }).then(() => {
      WSSuccessAlert("", `successfully`);
    });;

    // Send notification
    const notificationData = {
      BroadcastDocumentId: documentData.BroadcastDocumentId,
      EmployeeId: UserInfo.UserId,
    };

    await WebService({
      endPoint: `Document/SendNotification`,
      method: "POST",
      body: notificationData,
      dispatch,
    }).then(() => {
      WSSuccessAlert("", `Document '${documentData?.Title}' has been signed successfully`);
    });

    if (prop.callBackEvent) {
      prop.callBackEvent();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body>
        <div
          className="swal2-icon swal2-warning swal2-icon-show mt-0"
          style={{ display: "flex" }}
        >
          <div className="swal2-icon-content">!</div>
        </div>
        <h2
          className="swal2-title"
          id="swal2-title"
          style={{ display: "block", color: "#545454" }}
        >
          Confirm Document Signing
        </h2>
        <div
          className="swal2-html-container mx-0"
          id="swal2-html-container"
          style={{ display: "block", color: "#545454" }}
        >
          By clicking 'Yes, Sign it!', you confirm that you have reviewed the
          document '{documentData?.Title}' and agree to its terms. Your location will be recorded as part of your signature. This action is
          final and cannot be undone.
        </div>

        {coordinates.latitude && coordinates.longitude && (
          <div className="text-center my-2">
            <small className="text-muted">
              📍 Location: {coordinates.latitude.toFixed(6)}, {coordinates.longitude.toFixed(6)}
            </small>
          </div>
        )}

        <span className="d-flex justify-content-center gap-2 mt-3">
          <Button
            variant="secondary"
            style={{ fontWeight: "bold" }}
            onClick={handleClose}
          >
            No, Review Again
          </Button>
          <Button
            variant="primary"
            style={{ fontWeight: "bold" }}
            onClick={SignDocument}
          >
            Yes, Sign it!
          </Button>
        </span>
      </Modal.Body>
    </Modal>
  );
};

export default forwardRef(BroadcastSignatureModal);